import React, { Component } from 'react';

import { Button, Icon } from 'antd';

import fetch from './../services/fetch';

class Toolbar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: ''
        }
    }

    componentDidMount () {
        this.getLinkUrl(this.props.exports || {});
    }

    getLinkUrl (exports) {

        const baseURL = `${fetch.base}${exports.type}`;
        const session = JSON.parse(sessionStorage.session);
        const account = session.account;

        const keywords = [];

        for (var key in exports.keywords) {
            var value = exports.keywords[key];
            if (value === undefined) {
                keywords.push(`${key}=${""}`)
            } else {
                keywords.push(`${key}=${value}`)
            }

        }

        var url = `${baseURL}?${keywords.join('&')}`;

        this.setState({
            url
        });
    }

    componentWillReceiveProps (nextProps) {
        this.getLinkUrl(nextProps.exports || {});
    }


    render () {
        const props = this.props;
        return (
            <div className="root-toolbar">
                <a href={props.onInsertVisiable ? "javascript:;" : props.service.insertURL} onClick={() => {
                    if (props.onInsertVisiable) {
                        props.onInsertVisiable();
                    }
                }}><Icon type="file" />新增</a>

                {
                    props.onUpdateVisiable ? (<a href="javascript:;" onClick={() => {
                        if (props.onUpdateVisiable) {
                            props.onUpdateVisiable();
                        }
                    }}><Icon type="edit" />修改</a>) : (<a href="javascript:;" className="editor" onClick={() => {
                        props.service.batchUpdate();
                    }}><Icon type="edit" />修改</a>)
                }


                {
                    props.noDelete ? "" :
                        <a href="javascript:;" className="delete" onClick={() => {
                            props.service.batchRemove();
                        }}><Icon type="delete" />删除</a>
                }


                {
                    props.exports ?
                        (<a href={this.state.url} target="_blank"><Icon type="export" />导出</a>) : ''
                }

                {
                    props.onDetailVisiable ? (<a href="javascript:;" onClick={() => {
                        if (props.onDetailVisiable) {
                            props.onDetailVisiable();
                        }
                    }}><Icon type="search" />详情</a>) : ''
                }

                {
                    this.props.onUserPwd ? (<a href="javascript:;" className="user" onClick={() => {
                        this.props.onUserPwd('user');
                    }}><Icon type="user" />密码批量初始化</a>) : ''
                }

                {
                    this.props.onUsersPwd ? (<a href="javascript:;" className="group" onClick={() => {
                        this.props.onUsersPwd('users');
                    }}><Icon type="usergroup-add" />所有密码初始化</a>) : ''
                }

                {
                    this.props.children ? this.props.children : ""
                }

            </div>
        );
    }
}

export default Toolbar;